
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1fcus_3t65z_141",
  "clickable": "awsui_clickable_1fcus_3t65z_150",
  "precise": "awsui_precise_1fcus_3t65z_154",
  "focus-outline": "awsui_focus-outline_1fcus_3t65z_158",
  "application": "awsui_application_1fcus_3t65z_167"
};
  